import { PropertyCtaStoreFactory } from 'common/module/property-cta/store.factory';

const service = PropertyCtaStoreFactory();

service.initialize();

export const PropertyCtaService = () => service;
